<template>
  <div class="infrared-cotainer">
    <v-chart :options="barOption" :autoresize="true"></v-chart>
  </div>
</template>

<script>
import { statChart } from '@/echartOption/stat';

export default {
  components: {},
  props: {
    optionData: {
      type: Array
    }
  },
  data() {
    return {
      barOption: null
    };
  },
  watch: {
    optionData: {
      handler(newVal) {
        this.packageData(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {
    packageData(val) {
      let Xarr = [];
      let Yarr = [];
      val.forEach(item => {
        let str = `${item.deviceName}(${item.dt})`;
        Xarr.push(str);
        Yarr.push(item.infraredCount);
      });

      this.barOption = statChart({
        xAxis: {
          type: 'category',
          data: Xarr,
          name: '设备名称(时间)'
        },
        yAxis: {
          type: 'value',
          name: '红外线数值'
        },
        series: [
          {
            data: Yarr,
            type: 'bar',
            showBackground: true,
            barMaxWidth: 20,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ],
        grid: { bottom: '10%', top: '8%' },
        legend: {
          type: 'scroll',
          bottom: '5%',
          left: 'center',
          pageTextStyle: {
            color: '#00eeff'
          },
          textStyle: {
            color: '#00eeff'
          }
        },
        animation: false
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.infrared-cotainer {
  width: 100%;
  height: 800px;
}
</style>
